import React from "react"
import { Container, Row, Col } from "react-bootstrap"
import HeroCategory from "@components/hero-category"
import { graphql, useStaticQuery, Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import HeroBlogPost from "../../../components/hero-blog-post"
import {
    HeroOneArea,
    HeroInnerArea,
    HeroCategoryArea,
    HeroBlogPostArea,
    HeroBannerArea,
} from "./style"

/* OLD query
query HeroBlogPostQuery {
            categories: allCategoriesJson(limit: 4) {
                edges {
                    node {
                        name
                        image {
                            childImageSharp {
                                gatsbyImageData(width: 260, height: 110, quality: 100)
                            }
                        }
                    }
                }
            }
            heroBlogPost:allMarkdownRemark(
                sort: {fields: [frontmatter___date], order: DESC},
                limit: 2
            ) {
                edges {
                    node {
                        id
                        frontmatter {
                            title
                            date(formatString: "DD MMMM YYYY")
                            categories {
                                name
                                color
                            }
                            is_featured
                            thume_image {
                                childImageSharp {
                                    gatsbyImageData(width: 750, height: 400,quality: 100)
                                }
                            }
                            author {
                                name
                            }
                        }
                        fields {
                            slug
                            authorId
                            dateSlug
                        }
                        excerpt(pruneLength: 80)
                    }
                }
            }
        }

* */

const HeroOne = () => {
    const heroBlogPostQuery = useStaticQuery(graphql`
        query HeroBlogPostQuery {
            categorias: allMongodbArchivosCategorias(limit: 4) {
                edges {
                    node {
                        id
                        name
                        image
                        localImage {
                            childImageSharp {
                                gatsbyImageData(
                                    width: 260
                                    height: 110
                                    quality: 100
                                )
                            }
                        }
                    }
                }
            }
            heroBlogPost: allMongodbArchivosBlogDetails(
                sort: { fields: [jfrontmatter___date], order: DESC }
                limit: 2
                filter: {esPublicado: {eq: true}}
            ) {
                edges {
                    node {
                        id
                        jfields {
                            slug
                            authorId
                            dateSlug
                        }
                        jexcerpt
                        jfrontmatter {
                            title
                            date(formatString: "DD MMMM YYYY")
                            categories {
                                name
                                color
                            }
                            author {
                                name
                            }
                        }
                    }
                }
            }
        }
    `)
    console.log(heroBlogPostQuery)
    const { categorias, heroBlogPost } = heroBlogPostQuery
    return (
        <HeroOneArea>
            <Container>
                <Row>
                    <Col lg={12}>
                        <HeroInnerArea>
                            <HeroCategoryArea>
                                {categorias.edges.map((cat) => (
                                    <HeroCategory
                                        key={cat.node.name}
                                        name={cat.node.name}
                                        image={cat.node.localImage}
                                    />
                                ))}
                            </HeroCategoryArea>

                            <HeroBannerArea>
                                <Link to="/">
                                    <StaticImage
                                        src="../../../data/images/crda/noticias-artes01.jpg"
                                        alt=""
                                    />
                                </Link>
                            </HeroBannerArea>

                            <HeroBlogPostArea>
                                {heroBlogPost &&
                                    heroBlogPost.edges.map((post, i) => {
                                        return (
                                            <HeroBlogPost
                                                key={`heropost-${i}`}
                                                title={
                                                    post.node.jfrontmatter.title
                                                }
                                                categories={
                                                    post.node.jfrontmatter
                                                        .categories
                                                }
                                                body={post.node.jexcerpt}
                                                date={
                                                    post.node.jfrontmatter.date
                                                }
                                                authorSlug={
                                                    post.node.jfields.authorId
                                                }
                                                slug={post.node.jfields.slug}
                                                dateSlug={
                                                    post.node.jfields.dateSlug
                                                }
                                            />
                                        )
                                    })}
                            </HeroBlogPostArea>
                        </HeroInnerArea>
                    </Col>
                </Row>
            </Container>
        </HeroOneArea>
    )
}

export default HeroOne
